import view from '@/mixins/view'
import { TweenMax } from 'gsap' // eslint-disable-line

import { populate, sort } from '@/data'
// import Pole from '@/components/pole'
require('gsap/ScrollToPlugin')

export default {
  name: 'tpl-expertises',
  mixins: [view],
  data () {
    return {
      page: null,
      expertises: []
    }
  },
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })
      this.ready = true
      TweenLite.to(window, 1, { scrollTo: this.anchor })
    })
  },
  mounted () {
    this.anchor = this.$router.currentRoute.hash
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get('page', params.post_id),
        store.getters.get('expertise'),
        store.getters.get('work'),
        store.getters.get('partner'),
        store.getters.get('pole')
      ]).then(([page, expertises, works, partners, poles]) => {
        return { page, expertises, works, partners, poles }
      })
    },
    getPage: async function () {
      await this.fetchData(this.$store, this.$attrs).then(({ page, expertises, works, partners, poles }) => {
        this.page = page
        works = populate(works, partners, 'partner')
        expertises = sort(expertises, 'position', 'asc')
        expertises = populate(expertises, works, 'work')
        expertises = populate(expertises, poles, 'pole')
        console.log(poles)
        this.expertises = expertises
      })
    },
    mouseenter (item) {
      this.$refs[`link${item}`][0].mouseenter()
    },
    mouseleave (item) {
      this.$refs[`link${item}`][0].mouseleave()
    }
  }
}
